import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsHistogramPoint } from "@/http/api-types";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

export function CycleTimeHistogramChart({ data }: { data: JiraMetricsHistogramPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Cycle Time Histogram</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer className="h-72 w-full" config={{ count: { label: "Tickets", color: "#14b8a6" } }}>
          <BarChart data={data}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="label" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="count" fill="var(--color-count)" />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
